import { ILanguage } from '../../interface';

const ar: ILanguage = {
  locale: 'ar',
  translations: {
    notifications: 'إشعارات',
    markAllAsRead: 'وضع علامة على الكل كمقروءة',
    noNotificationsTitle: 'لا توجد إخطارات حتى الآن',
    noNotificationsDescription: 'سنخبرك عندما نحصل على شيء جديد لك.',
    pinned: 'مثبت',
    markAsUnread: 'وضع علامة كغير مقروءة',
    markAsRead: 'وضع علامة كمقروءة',
    archive: 'أرشيف',
    expiresIn: 'تنتهي في',
    minute: 'دقيقة',
    minutes: 'دقائق',
    hour: 'ساعة',
    hours: 'ساعات',
    day: 'يوم',
    days: 'أيام',
    week: 'أسبوع',
    weeks: 'أسابيع',
    month: 'شهر',
    months: 'أشهر',
    year: 'سنة',
    years: 'سنوات',
    connecting: 'جارٍ الاتصال…',
    connectionIssue:
      'يبدو أن هناك مشكلة في الاتصال. قد تتأخر الإشعارات الجديدة أو لا تصل.',
    offlineMessage:
      'أنت غير متصل بالإنترنت. أعد تحميل الصفحة لتحديث الإشعارات عند عودة الاتصال.',
    authError: 'تعذّر جلب الإشعارات بسبب مشكلة في المصادقة أو الأذونات.',
    reportIssue: 'الإبلاغ عن مشكلة',
    refreshPage: 'تحديث الصفحة',
    issueReported: 'تم الإبلاغ عن المشكلة',
    reportLimitExceeded: 'تم تجاوز حد الإبلاغ. حاول لاحقًا.',
  },
};

export default ar;
